const Module = () => import('./DIModule.vue');

import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next({ path: to.path });
  } else {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next();
  }
};

const setBreadcrumbs = (to) => {
  let breadcrumbs = [];
  const authStore = useAuthStore();

  if (authStore.user.isAdminUser && to.name === 'diannualreport') {
      breadcrumbs.push({ label: 'Review Annual Reports', route: '/program/annualreports' });
      breadcrumbs.push({ label: to.meta.title });
  } else {
    breadcrumbs = to.meta.breadcrumb;
  }

  return breadcrumbs;
};

const moduleRoutes = {
  path: '/di',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'diannualreport',
          props: true,
          meta: {
              title: 'Diagnostic Imaging Annual Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Diagnostic Imaging Annual  Report' }
              ]
          },
          component: () => import('./views/DIReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};